/**
 * 基于 `ua-parser-js` 扩展
 * 可任意扩展
 */


import UAParser from 'ua-parser-js';
import { isArray, isString } from './type';
import * as utilObject from './object';

const NAVIGATOR_USER_AGENT = utilObject.get(window, 'navigator.userAgent', '');

/**
 * 解析 UA
 * 兼容“微信小程序”
 * 看文档 https://github.com/faisalman/ua-parser-js
 *
 * 常用的浏览器名称（`ua().browser.name`）：
 * - WeChat: 微信
 * - WechatMiniprogram: 微信小程序
 * - zuzuche: 租租车APP
 * - tantutravel: 探途旅行APP
 * - tantumap: 探途离线地图APP
 * - QQ: QQ
 * - QQBrowser: QQ浏览器
 * - QQBrowserLite: QQ浏览器Lite
 *
 * @export
 * @param {string} [userAgent='']
 * @returns {Object}
 */
export default function parse(userAgent = NAVIGATOR_USER_AGENT) {
  // fix 微信小程序
  if (window && window.__wxjs_environment === 'miniprogram') {
    userAgent += ' miniprogram';
  }

  return UAParser(userAgent, {
    browser: BROWSER_EXTENSIONS
  });
}

/**
 * 快捷方法
 */
// 微信小程序
export function isWebchatMiniprogram(userAgent = NAVIGATOR_USER_AGENT) {
  const browser = parse(userAgent).browser;

  return browser.name === 'WechatMiniprogram';
}
// 自家APP
export function isHostApp(userAgent = NAVIGATOR_USER_AGENT) {
  const browser = parse(userAgent).browser;

  return ['zuzuche', 'tantutravel', 'tantumap'].indexOf(browser.name) !== -1;
}


const BROWSER_EXTENSIONS = convertBrowserExtensions([
  {
    name: 'zuzuche',
    regexes: [/(zzcios|zzcandroid)\/([\d.]+)/i]
  },
  {
    name: 'tantutravel',
    regexes: [/(\/com\.tantu\.travel)\/([\d.]+)/i]
  },
  {
    name: 'tantumap',
    regexes: [/(\/com\.tantu\.map)(?:[\w\d.]+|)\/([\d.]+)/]
  },
  {
    name: 'WechatMiniprogram',
    regexes: [/(micromessenger)\/([\d.]+)(?:.+)(miniprogram)/i]
  },
  {
    name: 'blackcard',
    regexes: [/\/black\/([0-9.]+)/i]
  }
]);

/**
 * 将“直观”的配置转化为 UAPaser “不直观”的配置
 */
function convertBrowserExtensions(extensions = []) {
  const result = [];

  extensions.forEach((browser) => {
    if (!isArray(browser.regexes)) {
      throw new TypeError('browser.regexes is not Array');
    }

    if (!isString(browser.name)) {
      throw new TypeError('browser.name is not String');
    }

    result.push(browser.regexes);
    result.push([
      [UAParser.BROWSER.NAME, browser.name],
      UAParser.BROWSER.VERSION
    ]);
  });

  return result;
}
